import security from "../../../main";
import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";
import { getApiBaseUrl } from "@/config";
import Exchange from "@/modules/inb/service/private/Exchange";
import Customer from "@/modules/inb/service/private/Customer";
import Message from "@/modules/inb/service/private/Message";

export default {
    url: {
        overview    : "/api/inbox/data",
        enums       : "/api/inbox/enums",
        upload      : "/api/inbox/upload",
        bulkupload  : "/api/inbox/bulkupload",
        download    : '/api/inbox/download/',
        incident    : "/api/inbox/incident/{0}",
        overwrite   : "/api/inbox/incident/{0}?overwrite={1}",
        ignore      : "/api/inbox/data/{0}/ignore?value={1}",
        dataid      : '/api/inbox/data/{0}',
        morph       : '/api/inbox/data/{0}/morph',
        data        : '/api/inbox/data',
        messageCount: '/api/inbox/data/count',
        total       : '/api/inbox/data/total',
        types       : '/api/inbox/type',
        invoicetypes: '/api/inbox/invoice/type',
        imports     : "/api/inbox/imports",
        counts      : "/api/inbox/imports/counts",
    },

    event: {
        refresh: "inbox-changed",
        attached: "inb-doc-attached",
        attachment: "inb.attachment.changed",
    },

    type: {
        assessment : "ASSESSMENT",
        incident   : "INCIDENT",
        invoice    : "INVOICE",
        maintenance: "MAINTENANCE",
        biddata    : "BID",
        default    : "DEFAULT"
    },

    component (typeId) {
        switch (typeId) {
            case 'AssessmentDto':
                return 'inbox-assessment';
            case 'IncidentDto':
                return 'inbox-incident';
            case 'InvoiceDto':
                return 'inbox-invoice';
            case 'MaintenanceDto':
                return 'inbox-maintenance'
            case 'BiddataDto':
                return 'inbox-default'
            case 'InboxItemDto':
                return 'inbox-default'
        }
    },

    exchange: Exchange,
    customer: Customer,
    message : Message,

    refresh (component) {
        component.$root.$emit(this.event.refresh);
    },

    goto (component, id, type ) {
        const routname = this.component(type);
        if (component.$route.name === routname) {
            console.log("route")
        } else {
            component.$router.push ({name: routname, params: { id: id } }).then(() => {})
        }
    },

    uploadFiles: function (component, files, force) {
        Core.loading(component, true, component.$t("inb.loading.upload"));
        let formData = new FormData();
        formData.append ("force", force);
        Array.from(files).forEach ((file,index) => {
            formData.append ("file_" + index, file);
        });

        return fetch(getApiBaseUrl() + this.url.bulkupload, {
            method:'POST',
            headers: security.header(),
            body: formData
        }).then(response => {
            if (response.ok) {
                return response;
            }

            return new Promise((resolved, reject) => {
                reject(response.json());
            })
        })
            .then(res => res.json())
            .then(res => {
                Core.loading(component, false);
                component.$bus.$emit(this.event.refresh);

                return res;
            });
    },

    upload: function (component, file, force) {
        Core.loading(component, true, component.$t("inb.loading.upload"));

        let formData = new FormData();
        formData.append("file", file);
        formData.append("force", force);

        return fetch(getApiBaseUrl() + this.url.upload, {
            method:'POST',
            headers: security.header(),
            body: formData
        })
            .then(response => {
                if (response.ok) {
                    return response;
                }

                return new Promise((resolved, reject) => {
                    reject(response.json());
                });
            }).then(res => res.json())
            .then(res => {
                Core.loading(component, false);
                component.$bus.$emit(this.event.refresh);

                return res;
            })
            .catch(e => {
                return e.then(m => {
                    Core.loading(component, false);
                    return new Promise((resolved, reject) => {
                        reject(m);
                    });
                })
            });
    },

    load(component, id, success) {
        Core.method.get(this.url.dataid, id).then((data) => {
            success(data, this.url.download);
        });
    },

    imports: function (component, filter) {
        Core.loading(component, true);
        return Core.method.post(this.url.imports, filter)
            .then ((data) => {
                Core.loading(component, false);
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    create: function (component, messageId, message) {
        console.log("**** CREATE " + message)
        Core.loading(component, true, message);
        return Core.method.post(this.url.incident, null, messageId)
            .then ((data) => {
                Core.loading(component, false);
                component.$bus.$emit(this.event.refresh);
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.loading(component, false);
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    store (component, message) {
        return Core.method.put (this.url.data, message)
            .then((data) => {
                this.refresh(component);
                Core.message.alert.save(component);
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    // silent: skip the refresh event/alert for this call - used when morphing many items in a
    // batch (e.g. after a bulk upload), where the caller emits one refresh after the whole
    // batch settles instead of once per item.
    morph (component, message, targetId, silent = false) {
        console.log(message)
        return Core.method.put (this.url.morph, {
            message : message,
            targetId: targetId
        }, message.id)
            .then((data) => {
                if (!silent) {
                    Core.message.alert.save(component);
                    component.$bus.$emit(this.event.refresh);
                }
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    attach: function (component, messageId, incidentId, step, bid, overwrite, success) {
        const unit = component.$store.getters.site;

        let category = null;
        let unitId   = null;

        switch (step.stepClass) {
            case 'invoiceService':
                category = 'INC_INVOICE';
                break;
            case 'assessmentService':
                category = 'SITE_ASSESSMMENT';
                unitId   = unit.id;
                break;
            case 'maintenanceService':
                category = 'SITE_MAINTENANCE';
                unitId   = unit.id;
                break;
            case 'issueService':
                category = 'INBOX';
        }

        return Core.method.put(this.url.overwrite, {
            incidentId: incidentId,
            unitId    : unitId,
            bidId     : bid ? bid.id   : null,
            bidName   : bid ? bid.name : null,
            stepId    : step.id,
            category  : category,
        }, messageId, overwrite)
            .then((data) => {
                component.$bus.$emit(this.event.attached, incidentId);
                component.$bus.$emit(this.event.refresh);
                if (success) success (data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    detach: function (component, messageId) {
        return Core.method.delete(this.url.incident, null, messageId)
            .then ((data) => {
                component.$bus.$emit("inb-doc-deached", data);
                Inc.refresh(component);
                component.$bus.$emit(this.event.refresh);
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },

    ignore: function (component, messageId, value) {
        return this.setValue(this.url.ignore, component, messageId, value);
    },

    setValue: function (url, component, messageId, value) {
        return Core.method.put(url, null, messageId, value?"true":"false")
            .then ((data ) => {
                component.$bus.$emit(this.event.refresh);
                return Promise.resolve(data);
            })
            .catch ((data) => {
                Core.message.popup (component, data.id, data.parameter);
            });
    },
}